export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13996.917a4213.jpg";